export default __webpack_public_path__ + "static/media/poster-1.cd8e9963.png";